import {  put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../components/common/apiConfig";
import { handleNotificationAlertCatch , handleNotificationAlertTrySelect } from "../../../components/method/handleNotificationAlert";

export const actionTypes = {
    selectOfflineElectronicTransactionsPdf: "selectOfflineElectronicTransactionsPdf [Action]",
    selectOfflineElectronicTransactionsPdfLoading: "selectOfflineElectronicTransactionsPdfLoading [Action]",
    selectOfflineElectronicTransactionsPdfAsync: "selectOfflineElectronicTransactionsPdfAsync [Action]",
};

const inistiaState = {
    data: [],
    total:0,
    loading: false
};

export const reducerselectOfflineElectronicTransactionsPdf = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.selectOfflineElectronicTransactionsPdf:
            return {
                ...state,
                data: payload.image_file,
                total: payload.image_file ? Object?.keys(payload.image_file)?.length :0
            };
        case actionTypes.selectOfflineElectronicTransactionsPdfLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectOfflineElectronicTransactionsPdfLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "brokercustomer",
        method_type: "select_offline_electronic_transactions_pdf",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.selectOfflineElectronicTransactionsPdf, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectOfflineElectronicTransactionsPdfLoading, payload: false })

    }
}

export function* workerselectOfflineElectronicTransactionsPdf() {
    yield takeLatest(actionTypes.selectOfflineElectronicTransactionsPdfAsync, handleWorker);
}
